<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="专家名称"
        ><BusinessLookupSelect v-model="query.userId" type="users" placeholder="请选择专家"
      /></el-form-item>
      <el-form-item label="行业"><el-input v-model="query.industry" clearable /></el-form-item>
      <el-form-item label="审核状态"
        ><el-select v-model="query.auditStatus" clearable class="!w-120px"
          ><el-option
            v-for="(label, value) in auditLabels"
            :key="value"
            :label="label"
            :value="Number(value)" /></el-select
      ></el-form-item>
      <el-form-item label="上下架"
        ><el-select v-model="query.status" clearable class="!w-110px"
          ><el-option label="下架" :value="0" /><el-option label="上架" :value="1" /></el-select
      ></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="专家名称" min-width="120"
        ><template #default="scope"
          ><BusinessLookupName type="users" :id="scope.row.userId" /></template
      ></el-table-column>
      <el-table-column prop="expertTitle" label="专家头衔" min-width="160" />
      <el-table-column prop="industry" label="行业" width="120" />
      <el-table-column label="关联商品" min-width="140"
        ><template #default="scope"
          ><BusinessLookupName type="products" :id="scope.row.productId" /></template
      ></el-table-column>
      <el-table-column label="审核" width="100"
        ><template #default="scope">{{
          auditLabels[scope.row.auditStatus]
        }}</template></el-table-column
      >
      <el-table-column label="状态" width="90"
        ><template #default="scope">{{
          scope.row.status === 1 ? '上架' : '下架'
        }}</template></el-table-column
      >
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button
            v-if="scope.row.auditStatus === 0"
            v-hasPermi="['bosscircle:expert:audit']"
            link
            type="warning"
            @click="openAudit(scope.row)"
            >审核</el-button
          >
          <el-button v-else link type="primary" @click="openAudit(scope.row, true)">详情</el-button>
          <el-button
            v-if="scope.row.auditStatus === 1"
            v-hasPermi="['bosscircle:expert:update']"
            link
            :type="scope.row.status === 1 ? 'warning' : 'success'"
            @click="changeStatus(scope.row)"
            >{{ scope.row.status === 1 ? '下架' : '上架' }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="auditVisible" :title="audit.readonly ? '专家详情' : '专家审核'" width="800px">
    <el-descriptions :column="2" border class="mb-16px">
      <el-descriptions-item label="专家用户">{{ audit.row?.userId }}</el-descriptions-item>
      <el-descriptions-item label="专家头衔">{{ audit.row?.expertTitle || '-' }}</el-descriptions-item>
      <el-descriptions-item label="行业">{{ audit.row?.industry || '-' }}</el-descriptions-item>
      <el-descriptions-item label="关联商品">{{ audit.row?.productId || '-' }}</el-descriptions-item>
      <el-descriptions-item label="专家介绍" :span="2">{{
        audit.row?.introduction || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="服务信息" :span="2">{{
        audit.row?.serviceJson || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="审核状态">{{
        auditLabels[audit.row?.auditStatus ?? -1] || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="审核时间">{{ audit.row?.auditTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="审核备注" :span="2">{{
        audit.row?.auditRemark || '-'
      }}</el-descriptions-item>
    </el-descriptions>
    <template v-if="!audit.readonly && audit.row?.auditStatus === 0">
      <el-divider content-position="left">审核操作</el-divider>
      <el-form label-width="96px">
        <el-form-item label="审核结果">
          <el-radio-group v-model="audit.pass">
            <el-radio :value="true">通过</el-radio>
            <el-radio :value="false">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!audit.pass" label="驳回原因" required>
          <el-input
            v-model="audit.remark"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请填写驳回原因"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <el-button @click="auditVisible = false">{{ audit.readonly ? '关闭' : '取消' }}</el-button>
      <el-button
        v-if="!audit.readonly && audit.row?.auditStatus === 0"
        type="primary"
        :loading="audit.saving"
        @click="submitAudit"
        >提交审核</el-button
      >
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import * as ExpertApi from '@/api/business/expert'

defineOptions({ name: 'BossCircleExpert' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const auditVisible = ref(false)
const auditLabels: Record<number, string> = { 0: '待审核', 1: '通过', 2: '驳回' }
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined,
  industry: '',
  auditStatus: undefined,
  status: undefined
})
const audit = reactive({
  row: undefined as any,
  pass: true,
  remark: '',
  saving: false,
  readonly: false
})
const load = async () => {
  loading.value = true
  try {
    const data = await ExpertApi.getExpertPage(query)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openAudit = async (row: any, readonly = false) => {
  audit.pass = true
  audit.remark = ''
  audit.readonly = readonly || row.auditStatus !== 0
  try {
    audit.row = await ExpertApi.getExpert(row.id)
  } catch {
    audit.row = row
  }
  auditVisible.value = true
}
const submitAudit = async () => {
  if (!audit.row?.id) return
  if (!audit.pass && !audit.remark.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  audit.saving = true
  try {
    await ExpertApi.auditExpert({
      id: audit.row.id,
      version: audit.row.version,
      auditStatus: audit.pass ? 1 : 2,
      remark: audit.pass ? '' : audit.remark.trim()
    })
    message.success(audit.pass ? '已通过' : '已驳回')
    auditVisible.value = false
    await load()
  } finally {
    audit.saving = false
  }
}
const changeStatus = async (row: any) => {
  const status = row.status === 1 ? 0 : 1
  await message.confirm(`确认${status === 1 ? '上架' : '下架'}该专家吗？`)
  await ExpertApi.updateExpertStatus({ id: row.id, version: row.version, status })
  message.success('操作成功')
  await load()
}
onMounted(load)
</script>
